'use strict';
var incognitoTest, polyfillStore, tracky;

tracky = require('../../../core/frontend/groupon_modules/trackEvent');


/*
 * In-memory mock for local / sessionStorage
 * It is not persistent across pages.
 */

polyfillStore = function() {
  Storage.prototype._data = {};
  Storage.prototype.setItem = function(id, val) {
    return this._data[id] = String(val);
  };
  Storage.prototype.getItem = function(id) {
    if (this._data.hasOwnProperty(id)) {
      return this._data[id];
    } else {
      return null;
    }
  };
  Storage.prototype.removeItem = function(id) {
    return delete this._data[id];
  };
  Storage.prototype.clear = function() {
    return this._data = {};
  };
};


/**
 * Tries to use the sessionStorage setter, which fails in Safari incognito
 *
 * @param {String} env - SLS environment (desktop, touch, M16) to pass to tracky event
 */

incognitoTest = function(env) {
  var ref, ref1;
  if (env == null) {
    env = 'desktop';
  }
  try {
    if (typeof sessionStorage !== "undefined" && sessionStorage !== null) {
      sessionStorage.setItem('incognitotest', 'test');
    }
    if (typeof Groupon !== "undefined" && Groupon !== null) {
      if ((ref = Groupon.PageFlags) != null) {
        ref.isIncognito = false;
      }
    }
  } catch (error) {
    tracky("ls-likely-incognito-session-" + env);
    if (typeof Groupon !== "undefined" && Groupon !== null) {
      if ((ref1 = Groupon.PageFlags) != null) {
        ref1.isIncognito = true;
      }
    }
    polyfillStore();
  }
};

module.exports = {
  incognitoTest: incognitoTest,
  polyfillStore: polyfillStore
};

